import store from "../../../store";
import profile from './profile.vue';

window.USER_REG =  new Vue({
	store,
	el: 'div#user_profile',
	name : "USER_PROFILE",
	data () {
		return {

		}
	},
	created () {

	},
	components : {
		profile,
	}
});
